import React from 'react';
import { SortButton } from '../../../../../search/components/sort';
import { InstitutionProps } from '../../../models/arc-epi-props';




interface Props {
	settings: InstitutionProps,
}

export function AmendmentHistoryLabels(props: Props) {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.dateOfChangeLabel} name='date_of_change' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.timeOfChangeLabel} name='time_of_change' />
			</div>

			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.adoptionDateLabel} name='adoption_date' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.amendmentDateLabel} name='amendment_date' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.employerBaseContributionLabel} name='employer_base' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.employerMatchContributionLabel} name='employer_match' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.minimumScheduledHourLabel} name='minimum_scheduled_hours' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.allowMultipleContributionLabel} name='allow_multiple_contribution_schedules' />
			</div>
		</div>
	);

}